// Import the existing toast alert system
import { showToastAlerts } from './alerts.js';

document.addEventListener("DOMContentLoaded", function () {

    // Track polls shown in current modal session to avoid infinite loops
    let viewedPollsInSession = new Set();
    
    // Reset viewed polls when page loads
    function resetViewedPolls() {
        viewedPollsInSession.clear();
    }

    // Handle clicking on poll option wrapper (CSP-safe replacement for inline onclick)
    $(document).on('click', '.poll-option-wrapper', function(e) {
        // Don't trigger if clicking directly on the input or label
        if (e.target.tagName.toLowerCase() === 'input' || e.target.tagName.toLowerCase() === 'label') {
            return;
        }
        
        const $wrapper = $(this);
        const $input = $wrapper.find('input[type="radio"], input[type="checkbox"]');
        
        if ($input.length) {
            // For radio buttons, just click it
            if ($input.attr('type') === 'radio') {
                $input.prop('checked', true).trigger('change');
            } 
            // For checkboxes, toggle the state
            else if ($input.attr('type') === 'checkbox') {
                $input.prop('checked', !$input.prop('checked')).trigger('change');
            }
        }
    });

    $(document).on('click', '.poll-delete', (e) => {
        e.preventDefault();
        const select = e.currentTarget;

        const confirmed = confirm('Czy na pewno chcesz usunąć tę ankietę?\n\nUwaga: Zostaną usunięte wszystkie odpowiedzi i dane związane z ankietą. Ta operacja jest nieodwracalna.');
        if (confirmed) {
            const pollId = select.dataset.pollId;
            const ensembleSlug = select.dataset.ensembleslug;
            
            // Create form and submit
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = `/${ensembleSlug}/polls/${pollId}/delete/`;
            
            // Add CSRF token
            const csrfToken = document.querySelector('[name=csrfmiddlewaretoken]')?.value || 
                             document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ||
                             $.cookie('csrftoken');
            
            if (csrfToken) {
                const csrfInput = document.createElement('input');
                csrfInput.type = 'hidden';
                csrfInput.name = 'csrfmiddlewaretoken';
                csrfInput.value = csrfToken;
                form.appendChild(csrfInput);
            }
            
            document.body.appendChild(form);
            form.submit();
        }
    });

    // Fix Select2 recipients field after form validation errors
    function reinitializeRecipientsSelect2() {
        const $recipientsSelect = $('#id_recipients');
        
        if ($recipientsSelect.length) {
            let selectedValues = [];
            
            // Try to get selected values from data attribute first (from form_data)
            const selectedRecipientsData = $recipientsSelect.data('selected-recipients');
            
            if (selectedRecipientsData) {
                selectedValues = selectedRecipientsData.toString().split(',').filter(val => val.trim());
            } else {
                // Fallback: try to get from HTML 'selected' attributes
                const $selectedOptions = $recipientsSelect.find('option[selected]');
                $selectedOptions.each(function() {
                    selectedValues.push($(this).val());
                });
            }
            
            // Check if Select2 is already initialized
            if ($recipientsSelect.hasClass('select2-hidden-accessible')) {
                $recipientsSelect.select2('destroy');
            }
            
            // Set the values programmatically
            $recipientsSelect.val(selectedValues);
            
            // Reinitialize Select2 with proper width
            $recipientsSelect.select2({
                width: '100%'
            });
        }
    }
    
    // Call the fix function after a small delay to ensure DOM is ready
    setTimeout(reinitializeRecipientsSelect2, 100);

    // Handle voting form submission (only on polls page, not in modal)
    $(document).on('submit', '.poll-container:not(#pollModal *) .vote-form', function(e) {
        e.preventDefault();
        
        const $form = $(this);
        const $container = $form.closest('.poll-container');
        const pollId = $container.data('poll-id');
        const ensembleSlug = $container.data('ensemble-slug');
        
        const formData = new FormData(this);
        
        $.ajax({
            url: `/${ensembleSlug}/polls/${pollId}/vote/`,
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRFToken': $('[name=csrfmiddlewaretoken]').val()
            },
            success: function(response) {
                if (response.success) {
                    $container.html(response.html);
                }
            },
            error: function(xhr) {
                let errorMsg = 'Wystąpił błąd podczas głosowania';
                if (xhr.responseJSON && xhr.responseJSON.error) {
                    errorMsg = xhr.responseJSON.error;
                }
                showAlert('danger', errorMsg);
            }
        });
    });
    
    // Handle change vote button click (only outside modal)
    $(document).on('click', '.change-vote-btn:not(#pollModal .change-vote-btn)', function(e) {
        e.preventDefault();
        
        const $container = $(this).closest('.poll-container');
        const pollId = $container.data('poll-id');
        const ensembleSlug = $container.data('ensemble-slug');
        
        $.ajax({
            url: `/${ensembleSlug}/polls/${pollId}/partial/`,
            method: 'GET',
            data: {
                'force_voting_form': true  // Force voting form even if user voted
            },
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            success: function(response) {
                if (response.html) {
                    $container.html(response.html);
                } else {
                    console.error('No HTML in response');
                }
            },
            error: function(xhr) {
                showAlert('danger', 'Wystąpił błąd podczas ładowania formularza');
            }
        });
    });

    // Handle voters modal for public polls
    $(document).on('click', '.vote-count-clickable', function(e) {
        e.preventDefault();
        
        const optionId = $(this).data('option-id');
        const optionName = $(this).data('option-name');
        
        // Get poll ID from the closest poll results container
        const $pollResults = $(this).closest('.poll-results');
        const pollId = $pollResults.data('poll-id');
        
        // Get ensembleSlug - try modal context first, then URL
        let ensembleSlug;
        const modalContainer = document.getElementById('poll-content-container');
        if (modalContainer && modalContainer.dataset.ensembleSlug) {
            // We're in modal on home page
            ensembleSlug = modalContainer.dataset.ensembleSlug;
        } else {
            // We're on polls page
            ensembleSlug = window.location.pathname.split('/')[1];
        }
        
        // Show loading state in the correct modal
        $(`#modal-option-name-${pollId}`).text(optionName);
        $(`#modal-voters-list-${pollId}`).html('<div class="text-center"><i class="mdi mdi-loading mdi-spin"></i> Ładowanie...</div>');
        $(`#votersModal-${pollId}`).modal('show');
        
        // Fetch voters data
        $.ajax({
            url: `/${ensembleSlug}/polls/option/${optionId}/voters/`,
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRFToken': $('[name=csrfmiddlewaretoken]').val()
            },
            success: function(response) {
                if (response.success && response.voters) {
                    let votersHtml = '';
                    
                    if (response.voters.length > 0) {
                        votersHtml = '<ul class="list-group list-group-flush border rounded">';
                        response.voters.forEach(function(voter) {
                            votersHtml += `
                                <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 0.75rem 1rem;">
                                    <div>
                                        <i class="mdi mdi-account-circle text-primary me-2"></i><strong>${voter.name}</strong>
                                    </div>
                                    <small class="text-muted" style="font-size: 0.8rem;"><i class="mdi mdi-clock-outline me-1"></i>${voter.voted_at}</small>
                                </li>
                            `;
                        });
                        votersHtml += '</ul>';
                        
                        if (response.voters.length > 1) {
                            votersHtml = `<p class="mb-3 text-muted">Łącznie głosów: ${response.count}</p>` + votersHtml;
                        }
                    } else {
                        votersHtml = '<div class="text-center p-4 border rounded bg-light"><i class="mdi mdi-vote-outline text-muted mb-2 d-block" style="font-size: 2rem;"></i><p class="text-muted mb-0">Brak głosów na tę opcję</p></div>';
                    }
                    
                    $(`#modal-voters-list-${pollId}`).html(votersHtml);
                } else {
                    $(`#modal-voters-list-${pollId}`).html('<p class="text-danger">Błąd podczas ładowania listy głosujących</p>');
                }
            },
            error: function(xhr) {
                let errorMessage = 'Wystąpił błąd podczas ładowania listy głosujących';
                if (xhr.responseJSON && xhr.responseJSON.error) {
                    errorMessage = xhr.responseJSON.error;
                }
                $(`#modal-voters-list-${pollId}`).html(`<p class="text-danger">${errorMessage}</p>`);
            }
        });
    });

    // Handle non-voters modal for admins
    $(document).on('click', '.non-voters-clickable', function(e) {
        e.preventDefault();
        
        const pollId = $(this).data('poll-id');
        
        // Get ensembleSlug - try modal context first, then URL
        let ensembleSlug;
        const modalContainer = document.getElementById('poll-content-container');
        if (modalContainer && modalContainer.dataset.ensembleSlug) {
            // We're in modal on home page
            ensembleSlug = modalContainer.dataset.ensembleSlug;
        } else {
            // We're on polls page
            ensembleSlug = window.location.pathname.split('/')[1];
        }
        
        // Show loading state in the non-voters modal
        $(`#modal-non-voters-list-${pollId}`).html('<div class="text-center"><i class="mdi mdi-loading mdi-spin"></i> Ładowanie...</div>');
        $(`#nonVotersModal-${pollId}`).modal('show');
        
        // Fetch non-voters data
        $.ajax({
            url: `/${ensembleSlug}/polls/poll/${pollId}/non-voters/`,
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRFToken': $('[name=csrfmiddlewaretoken]').val()
            },
            success: function(response) {
                if (response.success && response.non_voters) {
                    let nonVotersHtml = '';
                    
                    if (response.non_voters.length > 0) {
                        nonVotersHtml = '<ul class="list-group list-group-flush border rounded">';
                        response.non_voters.forEach(function(member) {
                            nonVotersHtml += `
                                <li class="list-group-item" style="padding: 0.75rem 1rem;">
                                    <i class="mdi mdi-account-circle text-warning me-2"></i><strong>${member.name}</strong>
                                </li>
                            `;
                        });
                        nonVotersHtml += '</ul>';
                        
                        if (response.non_voters.length > 1) {
                            nonVotersHtml = `<p class="mb-3 text-muted">Liczba osób, które nie zagłosowały: ${response.count}</p>` + nonVotersHtml;
                        }
                    } else {
                        nonVotersHtml = '<div class="text-center p-4 border rounded bg-light"><i class="mdi mdi-check-all text-success mb-2 d-block" style="font-size: 2rem;"></i><p class="text-success mb-0">Wszyscy uprawnieni zagłosowali!</p></div>';
                    }
                    
                    $(`#modal-non-voters-list-${pollId}`).html(nonVotersHtml);
                } else {
                    $(`#modal-non-voters-list-${pollId}`).html('<p class="text-danger">Błąd podczas ładowania listy osób, które nie zagłosowały</p>');
                }
            },
            error: function(xhr) {
                let errorMessage = 'Wystąpił błąd podczas ładowania listy osób, które nie zagłosowały';
                if (xhr.responseJSON && xhr.responseJSON.error) {
                    errorMessage = xhr.responseJSON.error;
                }
                $(`#modal-non-voters-list-${pollId}`).html(`<p class="text-danger">${errorMessage}</p>`);
            }
        });
    });

    // Home page poll modal functionality
    $(document).ready(function() {
        // Reset viewed polls when starting a new session
        resetViewedPolls();
        
        // Show poll modal automatically if it exists
        const $pollModal = $('#pollModal');
        if ($pollModal.length) {
            // Load poll content first, then show modal
            const pollContainer = document.getElementById('poll-content-container');
            if (pollContainer) {
                const pollId = pollContainer.dataset.pollId;
                const ensembleSlug = pollContainer.dataset.ensembleSlug;
                
                loadPollContent(pollId, ensembleSlug);
            }
            
            // Show modal after a short delay
            setTimeout(() => {
                $pollModal.modal('show');
            }, 500);
        }

        // Handle Esc key to close poll modal
        $(document).on('keydown', function(e) {
            if (e.key === 'Escape' && $('#pollModal').hasClass('show')) {
                $('#pollModal').modal('hide');
            }
        });

        // Handle close button (X) in modal header
        $(document).on('click', '#poll-close-btn', function(e) {
            $('#pollModal').modal('hide');
        });
    });

    // Handle poll footer button clicks (in modal)
    $(document).on('click', '#poll-close-footer-btn', function(e) {
        const btnText = $(this).text().trim();
        
        if (btnText === 'Następna ankieta') {
            // User wants to see next poll
            e.preventDefault();
            
            const modalContainer = document.getElementById('poll-content-container');
            const ensembleSlug = modalContainer.dataset.ensembleSlug;
            
            loadNextPollInModal(ensembleSlug);
        } else if (btnText === 'Zamknij') {
            // User wants to close modal
            $('#pollModal').modal('hide');
        }
        // For other cases, let default behavior work
    });

    // Handle modal header close button (X)
    $(document).on('click', '#poll-close-btn', function(e) {
        e.preventDefault();
        $('#pollModal').modal('hide');
    });

    // Handle modal close/hide event - check for next polls when modal is closed
    $(document).on('hidden.bs.modal', '#pollModal', function(e) {
        // Only proceed if the main poll modal is being closed, not a nested modal
        if (e.target.id !== 'pollModal') {
            return;
        }
        
        // Get ensemble slug and poll ID from the modal container
        const modalContainer = document.getElementById('poll-content-container');
        if (modalContainer && modalContainer.dataset.ensembleSlug) {
            const ensembleSlug = modalContainer.dataset.ensembleSlug;
            const currentPollId = modalContainer.dataset.pollId;
            
            // Small delay to ensure any pending operations complete
            setTimeout(() => {
                checkForAvailablePolls(ensembleSlug, currentPollId);
            }, 100);
        }
    });

    // Function to check for available polls and show modal if any exist
    function checkForAvailablePolls(ensembleSlug, excludePollId = null) {
        // Add current poll to viewed list if provided
        if (excludePollId) {
            viewedPollsInSession.add(parseInt(excludePollId));
        }
        
        // Get all available polls first, then filter out viewed ones in JavaScript
        $.ajax({
            url: `/${ensembleSlug}/polls/popup-poll/`,
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            success: function(response) {
                if (response.success && response.has_next_poll && response.all_polls) {
                    // Filter out polls that were already viewed in this session
                    const availablePolls = response.all_polls.filter(poll => 
                        !viewedPollsInSession.has(poll.id)
                    );
                    
                    if (availablePolls.length > 0) {
                        // Show the first unviewed poll
                        const poll = availablePolls[0];
                    
                    // Update modal content
                    $('#pollModalLabel').html(`<i class="mdi mdi-vote"></i> ${poll.title}`);
                    
                    // Update modal body description
                    const $modalBody = $('#poll-modal-body');
                    if (poll.description) {
                        const existingDesc = $modalBody.find('.mb-3:first');
                        if (existingDesc.length) {
                            existingDesc.html(poll.description);
                        } else {
                            $modalBody.prepend(`<div class="mb-3">${poll.description}</div>`);
                        }
                    } else {
                        $modalBody.find('.mb-3:first').remove();
                    }
                    
                    // Update container data attributes
                    const container = document.getElementById('poll-content-container');
                    container.dataset.pollId = poll.id;
                    container.dataset.ensembleSlug = poll.ensemble_slug;
                    
                    // Update dismiss button and reset voted state for new poll
                    $('#dismiss-poll-btn')
                        .attr('data-poll-id', poll.id)
                        .attr('data-ensemble-slug', poll.ensemble_slug)
                        .removeAttr('data-voted')
                        .removeClass('d-none')
                        .removeAttr('style')
                        .show();
                    
                    // Reset footer button
                    $('#poll-close-footer-btn').text('Zamknij').removeClass('btn-primary').addClass('btn-secondary');
                    
                        // Load poll content and show modal
                        loadPollContent(poll.id, poll.ensemble_slug);
                        $('#pollModal').modal('show');
                    }
                }
            },
            error: function(xhr) {
                console.error('Error checking for available polls:', xhr);
            }
        });
    }

    // Load poll content into modal
    function loadPollContent(pollId, ensembleSlug) {
        const container = $('#poll-content-container');
        
        // Update container attributes for the new poll
        container.attr('data-poll-id', pollId);
        container.attr('data-ensemble-slug', ensembleSlug);
        
        $.ajax({
            url: `/${ensembleSlug}/polls/${pollId}/partial/`,
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            success: function(response) {
                if (response.html) {
                    container.html(response.html);
                    
                    // Check if loaded content contains voting form or results by looking at the container after loading
                    setTimeout(() => {
                        const hasVotingForm = container.find('.poll-voting-form').length > 0;
                        const hasResults = container.find('.poll-results').length > 0;
                        const isChangingVote = container.find('.changing-vote').length > 0;
                        const dismissBtn = $('#dismiss-poll-btn');
                        const hasVoted = dismissBtn.attr('data-voted') === 'true';
                        
                        if (hasVotingForm && !hasResults && !hasVoted && !isChangingVote) {
                            // This is a voting form and user hasn't voted yet AND is not changing vote - show dismiss button
                            dismissBtn.removeClass('d-none').removeAttr('style').show();
                        } else {
                            // This is poll results, or user has already voted, or user is changing vote - hide dismiss button
                            dismissBtn.attr('style', 'display: none !important').addClass('d-none');
                        }
                    }, 50);
                    
                    $('#poll-close-footer-btn').text('Zamknij').removeClass('btn-primary').addClass('btn-secondary');
                } else {
                    container.html('<p class="text-danger">Błąd podczas ładowania ankiety</p>');
                }
            },
            error: function(xhr) {
                let errorMessage = 'Wystąpił błąd podczas ładowania ankiety';
                if (xhr.responseJSON && xhr.responseJSON.error) {
                    errorMessage = xhr.responseJSON.error;
                }
                container.html(`<p class="text-danger">${errorMessage}</p>`);
            }
        });
    }

    // Handle poll voting in modal
    $(document).on('submit', '#pollModal .poll-voting-form', function(e) {
        e.preventDefault();
        
        const form = this;
        
        // Ensure we have a proper form element
        if (form.tagName !== 'FORM') {
            console.error('Expected FORM element, got:', form.tagName);
            return;
        }
        
        const formData = new FormData(form);
        
        // Get poll info from main modal container (more reliable than nested containers)
        const modalContainer = document.getElementById('poll-content-container');
        const pollId = modalContainer.dataset.pollId;
        const ensembleSlug = modalContainer.dataset.ensembleSlug;
        
        $.ajax({
            url: `/${ensembleSlug}/polls/${pollId}/vote/`,
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            success: function(response) {
                if (response.success && response.html) {
                    // Replace voting form with results
                    $('#poll-content-container').html(response.html);
                    
                    // Show success message
                    if (response.message) {
                        showAlert('success', response.message);
                    }
                    
                    // Update modal footer - hide "skip today" button permanently after voting
                    // This should stay hidden even if checkForNextPoll runs
                    const dismissBtn = $('#dismiss-poll-btn');
                    dismissBtn
                        .attr('data-voted', 'true')
                        .attr('style', 'display: none !important')
                        .addClass('d-none');

                    
                    // Check if there might be more polls and update button accordingly
                    // Add small delay to ensure vote is processed
                    setTimeout(() => {
                        checkForNextPoll(ensembleSlug);
                    }, 500);
                } else {
                    showAlert('danger', response.error || 'Wystąpił błąd podczas głosowania');
                }
            },
            error: function(xhr) {
                let errorMessage = 'Wystąpił błąd podczas głosowania';
                if (xhr.responseJSON && xhr.responseJSON.error) {
                    errorMessage = xhr.responseJSON.error;
                }
                showAlert('danger', errorMessage);
            }
        });
    });

    // Handle "change vote" button in modal
    $(document).on('click', '#pollModal .change-vote-btn', function(e) {
        e.preventDefault();
        
        // Get poll info from main modal container
        const modalContainer = document.getElementById('poll-content-container');
        const pollId = modalContainer.dataset.pollId;
        const ensembleSlug = modalContainer.dataset.ensembleSlug;
        
        $.ajax({
            url: `/${ensembleSlug}/polls/${pollId}/partial/?force_voting_form=true`,
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            success: function(response) {
                if (response.html) {
                    $('#poll-content-container').html(response.html);
                    
                    // Check if this is a change vote scenario - if so, hide dismiss button
                    const isChangingVote = $('#poll-content-container').find('.changing-vote').length > 0;
                    const dismissBtn = $('#dismiss-poll-btn');
                    
                    if (isChangingVote) {
                        // This is changing vote - hide dismiss button
                        dismissBtn.attr('style', 'display: none !important').addClass('d-none');
                    } else {
                        // Show "skip today" button again and clear voted status for new voting
                        dismissBtn.removeAttr('data-voted').removeClass('d-none').removeAttr('style').show();
                    }
                    
                    $('#poll-close-footer-btn').text('Zamknij').removeClass('btn-primary').addClass('btn-secondary');
                } else {
                    showAlert('danger', 'Błąd podczas ładowania formularza głosowania');
                }
            },
            error: function(xhr) {
                let errorMessage = 'Wystąpił błąd podczas ładowania formularza';
                if (xhr.responseJSON && xhr.responseJSON.error) {
                    errorMessage = xhr.responseJSON.error;
                }
                showAlert('danger', errorMessage);
            }
        });
    });

    // Handle "dismiss poll for today" button
    $(document).on('click', '#dismiss-poll-btn', function(e) {
        e.preventDefault();
        
        const pollId = this.dataset.pollId;
        const ensembleSlug = this.dataset.ensembleSlug;
        
        $.ajax({
            url: `/${ensembleSlug}/polls/${pollId}/dismiss/`,
            method: 'POST',
            data: {
                'csrfmiddlewaretoken': $('[name=csrfmiddlewaretoken]').val() || $.cookie('csrftoken')
            },
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            success: function(response) {
                if (response.success) {
                    // Show success message
                    if (response.message) {
                        showAlert('info', response.message);
                    }
                    
                    // Load next poll or close modal
                    loadNextPollInModal(ensembleSlug);
                } else {
                    showAlert('danger', response.error || 'Wystąpił błąd');
                }
            },
            error: function(xhr) {
                let errorMessage = 'Wystąpił błąd podczas pomijania ankiety';
                if (xhr.responseJSON && xhr.responseJSON.error) {
                    errorMessage = xhr.responseJSON.error;
                }
                showAlert('danger', errorMessage);
            }
        });
    });

    // Function to check if there are more polls and update button text
    function checkForNextPoll(ensembleSlug) {
        // Get current poll ID to exclude it
        const modalContainer = document.getElementById('poll-content-container');
        const currentPollId = modalContainer.dataset.pollId;
        
        $.ajax({
            url: `/${ensembleSlug}/polls/${currentPollId}/next/`,
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            success: function(response) {
                if (response.success && response.has_next_poll) {
                    // There are more polls - show "Next poll" button
                    $('#poll-close-footer-btn').text('Następna ankieta').removeClass('btn-secondary').addClass('btn-primary');
                } else {
                    // No more polls - show "Close" button
                    $('#poll-close-footer-btn').text('Zamknij').removeClass('btn-primary').addClass('btn-secondary');
                }
            },
            error: function(xhr) {
                console.error('Error checking for next poll:', xhr);
                // On error, show close button
                $('#poll-close-footer-btn').text('Zamknij').removeClass('btn-primary').addClass('btn-secondary');
            }
        });
    }

    // Function to load next poll in popup modal
    function loadNextPollInModal(currentEnsembleSlug) {
        // Get current poll ID to exclude it
        const modalContainer = document.getElementById('poll-content-container');
        const currentPollId = modalContainer.dataset.pollId;
        
        $.ajax({
            url: `/${currentEnsembleSlug}/polls/${currentPollId}/next/`,
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            success: function(response) {
                if (response.success && response.has_next_poll) {
                    // There's another poll - load it in the same modal
                    const nextPoll = response.poll;
                    
                    // Update modal title
                    $('#pollModalLabel').html(`<i class="mdi mdi-vote"></i> ${nextPoll.title}`);
                    
                    // Update container data attributes BEFORE loading content
                    const container = document.getElementById('poll-content-container');
                    container.dataset.pollId = nextPoll.id;
                    container.dataset.ensembleSlug = nextPoll.ensemble_slug;
                    
                    // Update description in modal body
                    const $modalBody = $('#poll-modal-body');
                    if (nextPoll.description) {
                        // Replace or add description
                        const existingDesc = $modalBody.find('.mb-3:first');
                        if (existingDesc.length) {
                            existingDesc.html(nextPoll.description);
                        } else {
                            $modalBody.prepend(`<div class="mb-3">${nextPoll.description}</div>`);
                        }
                    } else {
                        // Remove description if new poll has none
                        $modalBody.find('.mb-3:first').remove();
                    }
                    
                    // Update dismiss button data and show it - reset voted state for new poll
                    $('#dismiss-poll-btn')
                        .attr('data-poll-id', nextPoll.id)
                        .attr('data-ensemble-slug', nextPoll.ensemble_slug)
                        .removeAttr('data-voted')
                        .removeClass('d-none')
                        .removeAttr('style')
                        .show();
                    
                    // Reset footer button
                    $('#poll-close-footer-btn').text('Zamknij').removeClass('btn-primary').addClass('btn-secondary');
                    
                    // Load new poll content
                    loadPollContent(nextPoll.id, nextPoll.ensemble_slug);
                    
                } else {
                    // No more polls - close modal
                    $('#pollModal').modal('hide');
                }
            },
            error: function(xhr) {
                console.error('Error loading next poll:', xhr);
                // On error, just close the modal
                $('#pollModal').modal('hide');
            }
        });
    }

    // Function to show alerts using existing toast system
    function showAlert(type, message) {
        // Map alert types to toast types for consistency with Django messages
        const typeMapping = {
            'success': 'success',
            'danger': 'error', 
            'error': 'error',
            'warning': 'warning',
            'info': 'info'
        };
        
        const toastType = typeMapping[type] || 'info';
        
        // Create temporary alert element like Django messages system does
        const $tempAlert = $(`<div class="toast-alert d-none" data-alert-type="${toastType}">${message}</div>`);
        $('body').append($tempAlert);
        
        // Use existing toast system
        showToastAlerts($tempAlert);
        
        // Clean up temporary element after toast is shown
        setTimeout(() => {
            $tempAlert.remove();
        }, 100);
    }
});